import * as Yup from 'yup';
import { 
    stringWithNoSpecialChars,
    validateDate,
    validateNeedStatus,
    validateNumericId, 
    validateOperationType, 
    validateAmountRangeType, 
    validatePropertyCategory, 
    validatePropertyStanding, 
    validatePropertyType, 
    validatePropertyUsageType
} from "@/Shared/Helpers";
import { NeedEnums } from '@/Shared';

/**
 * =====================================================
 * Need Form Types and Validation
 * =====================================================
 *
 * Defines the structure and validation rules for the Need form:
 * - Maps each form field to its type
 * - Applies validation rules using Yup and custom helpers
 * - Ensures data integrity before submission
 *
 * Author: Samano CASTRE
 * Date: February 01, 2026
 */

/** Form values type for Need form */
export type NeedFormValues = {
    contactId?: number,
    operationType?: string,
    propertyCategory?: string,
    propertyType?: string,
    sectorId: number,
    cityId: number,
    priceRange? : string,
    propertyStanding? : string,
    status? : string;
    desiredStartAt?: string,
    maxServiceChargeProvision? : string,
     usageType: string,
};

/**
 * =====================================================
 * Need Form Validation Schema
 * =====================================================
 *
 * Creates a Yup validation schema for the Need form.
 * - Uses custom validators for enums and numeric IDs
 * - Ensures required fields are present
 * - Accepts `viewEnums` to validate enum-based fields dynamically
 *
 * @param viewEnums - All enums required for validation
 */
export const NeedValidationSchema =  (viewEnums: NeedEnums) => Yup.object({

    usageType: validatePropertyUsageType(viewEnums.PropertyUsageEnum, true),
    
    contactId: validateNumericId().required('Le prospect est requis'),

    desiredStartAt: validateDate().nullable().notRequired(),

    operationType: validateOperationType(viewEnums.OperationTypeEnum),

    propertyCategory: validatePropertyCategory(viewEnums.PropertyCategoryEnum),

    propertyType: validatePropertyType(viewEnums.PropertyTypeEnum),

    sectorId: validateNumericId().required('Le secteur du bien est requis.'),

    cityId: validateNumericId().required('La ville du bien est requise.'),

    priceRange : validateAmountRangeType(viewEnums.PriceRangeEnum),

    propertyStanding: validatePropertyStanding(viewEnums.StandingEnum),

    status : validateNeedStatus(viewEnums.NeedStatusEnum),
});
